var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75011 11.6667C8.75011 10.0558 10.0559 8.75 11.6668 8.75H58.3334C59.9443 8.75 61.2501 10.0558 61.2501 11.6667V40.3948L66.9545 58.9339C67.2267 59.8186 67.0628 60.7799 66.5129 61.5245C65.963 62.269 65.0924 62.7083 64.1668 62.7083H5.83344C4.90785 62.7083 4.0372 62.269 3.4873 61.5245C2.93741 60.7799 2.77355 59.8186 3.04575 58.9339L8.75011 40.3948V11.6667ZM13.8209 43.75L9.78249 56.875H24.1143L26.2404 50.1611C26.6242 48.9489 27.7493 48.125 29.0209 48.125H40.9793C42.2509 48.125 43.376 48.9489 43.7599 50.1611L45.8859 56.875H60.2177L56.1793 43.75H13.8209ZM55.4168 37.9167V14.5833H14.5834V37.9167H55.4168ZM39.7671 56.875L38.8435 53.9583H31.1567L30.2331 56.875H39.7671Z",
    fill: "#6BCF7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.ec3bbdca60e75f2ff8d6215e98dbf3fd.svg";
export { ForwardRef as ReactComponent };